import React from "react";
import "./navbar.css";

function Navbar() {
  return (
    <div className="navbarr">
      <a href="#day" className="nav-icon icon1">
        Tweet of the Day
      </a>
      <a href="#lgbtq" className="nav-icon icon2">
        LGBTQ+
      </a>
      <a href="#story" className="nav-icon icon3">
        Coming out Stories
      </a>
      <a href="#rights" className="nav-icon icon4">
        LGBT Rights
      </a>
      <a href="#trans" className="nav-icon icon5">
        Transgenders
      </a>
      <a href="#women" style={{borderRight:"none",marginRight:"0"}} className="nav-icon icon6">
        Women in Tech
      </a>
    </div>
  );
}

export default Navbar;
